<app-img-header
  title="Submarcas"
  alt="Daimler Truck"
  image="/assets/images/cotizador/intro.jpg"
  [contentTemplate]="template"
>
</app-img-header>
<app-preloader *ngIf="isLoading"></app-preloader>
<main class="main">
  <div id="detail">
    <div class="pageWidth">
      <div class="actionsWrapper">
        <button class="tertiary" (click)="create()">
          <i class="icon"></i> Nueva submarca
        </button>

        <div class="switchView">
          <a
            class="list"
            tp="Ver submarcas en lista"
            (click)="selectSection(1)"
            [ngClass]="{ active: showSection == 1 }"
            >Ver submarcas en lista</a
          >
          <a
            class="grid"
            tp="Ver submarcas en grilla"
            (click)="selectSection(2)"
            [ngClass]="{ active: showSection == 2 }"
            >Ver submarcas en grilla</a
          >
        </div>
      </div>

      <!-- Tabla con submarcas -->
      <div class="customTable submarcas" *ngIf="showSection == 1">
        <div class="header">
          <div class="cell imagen">Imagen</div>
          <div class="cell nombre">Nombre</div>
          <!--
          <div class="cell codigo">Código</div>
          -->
          <div class="cell modelos">Modelos</div>
          <div class="cell marca">Marca</div>
          <div class="cell habilitada">Habilitada</div>
          <div class="cell acciones"></div>
        </div>

        <div class="row" *ngFor="let subBrand of data">
          <div class="cell imagen">
            @if(subBrand.attachment){
            <!-- Si tiene imagen mostrar picture-->
            <picture>
              <img
                src="{{ subBrand.attachment.publicUrl || subBrand.attachment.urlSource }}"
                alt="{{ subBrand.name }}"
                lazy="true"
              />
            </picture>
            }@else{
            <!-- Si no tiene imagen mostrar div.noImage-->
            <div class="noImage">
              <span>Sin imagen</span>
            </div>
            }
          </div>
          <div class="cell nombre">{{ subBrand.name }}</div>
          <!--
          <div class="cell codigo">{{ subBrand.subBrandCode }}</div>
          -->
          <div class="cell modelos">
            <a (click)="goProducts(subBrand.id)">{{ subBrand.modelCount }}</a>
          </div>
          <div class="cell marca">
            <a (click)="goBrand()">{{ getBrandName(subBrand.brandId) }}</a>
          </div>

          <div class="cell habilitada">
            <img
              *ngIf="subBrand.enabled === true"
              src="../../assets/images/icons/notification_success.svg"
              alt="Si"
              class="available"
              tp="Habilitada"
            />

            <img
              *ngIf="subBrand.enabled === false"
              src="../../assets/images/icons/notification_error.svg"
              alt="No"
              class="notAvailable"
              tp="Deshabilitada"
            />
          </div>

          <div class="cell acciones">
            <a class="edit" tp="Editar" (click)="edit(subBrand, subBrand.id)"
              >Editar</a
            >
            <a class="delete" *ngIf="subBrand.availableToDelete" tp="Eliminar" (click)="openModalConfirmation(subBrand)">Eliminar</a>
          </div>
        </div>
      </div>

      <!-- Grilla con submarcas -->
      <div class="customGrid submarcas" *ngIf="showSection == 2">
        <div class="card" *ngFor="let subBrand of data">
          @if(subBrand.attachment){
          <!-- Si tiene imagen mostrar picture-->
          <picture>
            <img
              src="{{ subBrand.attachment.publicUrl || subBrand.attachment.urlSource }}"
              alt="{{ subBrand.name }}"
            />
          </picture>
          }@else{
          <!-- Si no tiene imagen mostrar div.noImage-->
          <div class="noImage">
            <span>Sin imagen</span>
          </div>
          }
          <div class="content">
            <div class="marca">
              <a (click)="goBrand()">{{ getBrandName(subBrand.brandId) }}</a>
            </div>
            <div class="nombreYCodigo">
              <div class="nombre">{{ subBrand.name }}</div>
              <!--
              <div class="codigo">{{ subBrand.subBrandCode }}</div>
              -->
            </div>

            <div class="modelos">
              <p>Cantidad de Modelos:</p>
              <a (click)="goProducts(subBrand.id)">{{ subBrand.modelCount }}</a>
            </div>

            <div class="wrapper">
              <div
                class="tag"
                [ngClass]="subBrand.enabled ? 'habilitada' : 'deshabilitada'"
              >
                {{ subBrand.enabled ? "Habilitada" : "Deshabilitada" }}
              </div>

              <div class="acciones">
                <a
                  class="edit"
                  tp="Editar"
                  (click)="edit(subBrand, subBrand.id)"
                  >Editar</a
                >
                <a class="delete" *ngIf="subBrand.availableToDelete" tp="Eliminar" (click)="openModalConfirmation(subBrand)">Eliminar</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--pagindador-->
      <div *ngIf="hasData">
        <app-paginator
          [total]="total"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          (changePage)="handlePage($event)"
        ></app-paginator>
      </div>

      <div class="actionsWrapper">
        <button class="tertiary" (click)="create()">
          <i class="icon"></i> Nueva submarca
        </button>
      </div>
    </div>
    <ng-template #template>
      <div class="wrapperG3">
        <div>
          <label>Nombre</label>
          <app-input
            [data]="searchName"
            (textSearch)="filter($event, 'name')"
            [resetInput]="reset"
          ></app-input>
        </div>
        <!--
        <div>
          <label>Codigo</label>
          <app-input
            [data]="searchCode"
            (textSearch)="filter($event, 'subBrandCode')"
            [resetInput]="reset"
          ></app-input>
        </div>
        -->
        <div>
          <label>Marca</label>
          <app-select
            [options]="searchBrand"
            [placeholder]="'Buscar por marca'"
            (optionSelected)="filter($event, 'brandId')"
            [resetSelect]="reset"
          ></app-select>
        </div>
        <div>
          <label>Estado</label>
          <app-select
            [options]="enabled"
            [placeholder]="'Buscar por estado'"
            (optionSelected)="filter($event, 'enabled')"
            [resetSelect]="reset"
          ></app-select>
        </div>
      </div>
      <div class="filtersActions">
        <button class="primary" (click)="search()">Buscar</button>
        <button class="secondary" (click)="resetFilters()">
          Limpiar filtros
        </button>
      </div>
    </ng-template>
  </div>
</main>
<!--Modal para crear/Editar-->
<ng-template #modalTemplate>
  <app-sub-brand-template
    [isEdit]="isEdit"
    [subBrandData]="selectedSubBrandData"
    (save)="onSaveBrand($event)"
    (update)="updateBrand($event)"
    (close)="closeModal()"
  >
  </app-sub-brand-template>
</ng-template>
<!--Modal para confirmar-->
<ng-template #templateConfirmation>
  <app-template-confirmation
    [title]="title"
    [subtitle]="subtitle"
    [btn1]="btn1"
    [btn2]="btn2"
    (closeModal)="closeModal()"
    (actionBtn2)="deletesubBrandById()"
  ></app-template-confirmation>
</ng-template>
